import React, { useState } from 'react';
import { Modal, Stack, TextInput, Button, Text, Notification } from '@mantine/core';
import { IconDatabaseImport, IconCheck, IconX } from '@tabler/icons-react';

export default function CeidgImportModal({ opened, onClose, user, apiBaseUrl, onImportSuccess }) {
  const [apiKey, setApiKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleImport = async () => {
    if (!user?.email) return;
    setLoading(true);
    setStatus(null);
    try {
      const res = await fetch(`${apiBaseUrl}/api/ceidg/import`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ apiKey, ownerEmail: user.email })
      });
      const data = await res.json();
      if (res.ok) {
        setStatus({ type: 'success', msg: `Zaimportowano pomyślnie ${data.importedCount || 0} rekordów z emailami.` });
        if (onImportSuccess) onImportSuccess();
      } else {
        setStatus({ type: 'error', msg: data.error || 'Błąd importu z CEIDG.' });
      }
    } catch (e) {
      setStatus({ type: 'error', msg: 'Wystąpił problem z połączeniem.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Import firm z CEIDG (Polska)" size="md">
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Pobieranie polskich firm posiadających adres e-mail (Tylko dane kontaktowe). 
          Rekordy zostaną dodane do nowego segmentu "poland_lead". Puste pole klucza oznacza użycie klucza przypisanego do konta.
        </Text>
        <TextInput
          label="Klucz API Biznes.gov.pl (Opcjonalnie)"
          placeholder="Pozostaw puste aby użyć zapisanego klucza"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
        />
        <Button onClick={handleImport} loading={loading} leftSection={<IconDatabaseImport size={16}/>} fullWidth color="green">
          Rozpocznij Import CEIDG
        </Button>
        {status?.type === 'success' && (
          <Notification icon={<IconCheck size={18} />} color="teal" title="Gotowe!" onClose={() => setStatus(null)}>
            {status.msg}
          </Notification>
        )}
        {status?.type === 'error' && (
          <Notification icon={<IconX size={18} />} color="red" title="Błąd" onClose={() => setStatus(null)}>
            {status.msg}
          </Notification>
        )}
      </Stack>
    </Modal>
  );
}
